import clsx from "clsx";
import React, { Ref } from "react";
import useDropdownPosition from "../useDropdownPosition";
import { eventButtonType } from "../../../../common/types/common";

interface SuggestionsProps {
	active?: string;
	codeFetchKey: string;
	dropdownIsOpened: boolean;
	onSuggestionSelected: (e: eventButtonType) => unknown;
	quickSearch?: boolean;
	suggestions: { name: string; code: string; disabled: boolean }[];
	value: string;
	loading?: boolean;
	dropdownRef?: Ref<HTMLDivElement>;
}

export default function Suggestions({
	active,
	value,
	suggestions,
	dropdownIsOpened,
	codeFetchKey,
	onSuggestionSelected,
	dropdownRef,
	quickSearch,
	loading,
}: SuggestionsProps) {
	const { isDropdownBelowViewport, isDropdownHidden } = useDropdownPosition(
		dropdownRef,
		dropdownIsOpened,
		quickSearch,
		[suggestions, loading, value],
	);

	if (value.length === 0 || suggestions.length === 0 || !dropdownIsOpened) {
		return null;
	}

	const handleSelect = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
		onSuggestionSelected(e.target.id);

	const options = suggestions.map((item) => {
		const { name, [codeFetchKey]: code, disabled = false } = item;

		return (
			<li
				key={code}
				aria-selected="false"
				className={clsx("autosuggest__suggestion", {
					active: code === active,
				})}
			>
				<button
					type="button"
					id={code}
					disabled={disabled}
					onClick={handleSelect}
				>
					{name}
				</button>
			</li>
		);
	});

	return (
		<div
			ref={dropdownRef}
			className={clsx("autosuggest__suggestions-container", {
				"autosuggest__suggestions-container--scrollable":
					suggestions.length > 10,
				"autosuggest__suggestions-container--inverted-y":
					isDropdownBelowViewport,
				"autosuggest__suggestions-container--hidden": isDropdownHidden,
			})}
		>
			{loading && (
				<div className="autosuggest__suggestions-loading loading">
					<div className="loader" />
				</div>
			)}
			{!loading && (
				<ul className="autosuggest__suggestions-list">{options}</ul>
			)}
		</div>
	);
}
